<header class="page-header">
  <kin-icon name="arrow_before" (iconClick)="location.back()" />
  <h1>{{ 'page.content_creation.name' | translate | upperFirstLetter }}</h1>
</header>

@if (editedId) {
  <app-content-availability-block
    class="field availability"
    [disponibilities]="disponibilities()"
    [loading]="editedContentResource.isLoading()"
    [isExpandable]="false"
  />
}

<div id="content-creation-content">
  <section class="content">
    <app-content-type-block
      [selectedContentType]="contentType()"
      [disabled]="!!editedId"
      (contentTypeSelected)="contentTypeChange($event)"
    />

    @switch (contentType()) {
      @case ('scenic') {
        <app-creation-scenic-form />
      }
      @case ('coaching') {
        <app-creation-coaching-form />
      }
      @case ('workout') {
        <app-creation-workout-form />
      }
      @case ('gps-only') {
        <app-creation-gps-only-form />
      }
    }

    @if (editedId && !isDeleted()) {
      <button class="delete-btn" (click)="deleteContent()">
        <kin-icon name="trash" [color]="colorService.danger500()" [size]="24" />
        {{ 'confirm_delete.button' | translate | upperFirstLetter }}
      </button>
    }
  </section>

  <app-content-preview
    mode="creation"
    [contentType]="contentType()"
    (onSubmitForm)="onSubmitAttempted()"
    (onSaveForm)="save()"
  />
</div>
